var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('header-reg-elem'),_c('notification-elem'),(_vm.provider.client_level)?_c('router-view'):_vm._e(),_c('footer-elem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }